import { toWorkflowData } from '@data/schemas/workflowData'
import { get } from 'lodash-es'

export const toLocalCommunityData = (data: unknown): TLocalcommunityWorkflowData => {
    return {
        workflow: toWorkflowData(data),
        workflowType: 'localcommunity',
        localcommunity: get(data, 'localcommunity'),
        user: get(data, '_embedded.user'),
    }
}
